import Rides from './Rides.jsx';
import './Rides.css';

export default Rides;
